import { render, staticRenderFns } from "./cate11.vue?vue&type=template&id=6bfb0e9a"
import script from "./cate11.vue?vue&type=script&lang=js"
export * from "./cate11.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports